import { Grid, TextField, Typography } from "@mui/material"
import { Control, Controller } from "react-hook-form"
import { useMobileView } from "../../../../Hooks/useMobileView"

interface EditAccountUserInfoProps {
    control: Control<any, any>
}
export const EditAccountUserInfo = ({ control }:EditAccountUserInfoProps) => {
    /* ******************** Hooks ******************** */
    const { flexDirection } = useMobileView();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid item display={"flex"} flexDirection={flexDirection} gap={'12px'}>
                <Grid  item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>First name</Typography> 
                    <Controller
                        name='first_name'
                        control={control}
                        render={({field}) =>(
                            <TextField
                                {...field}
                            />
                        )}
                    />
                </Grid>                            
                <Grid  item display={"flex"} flexDirection={"column"} flex={1}>
                    <Typography variant='body-small' color={'black.200'} marginBottom={1}>Last name</Typography> 
                    <Controller
                        name='last_name'
                        control={control}
                        render={({field}) =>(
                            <TextField
                                {...field}
                            />
                        )}
                    />
                </Grid>
            </Grid>
            <Grid item xs display={"flex"} flexDirection={"column"}>
                <Typography variant='body-small' color={'black.200'} marginBottom={1}>Email address</Typography> 
                    <Controller
                        name='email'
                        control={control}
                        render={({field}) =>(
                            <TextField
                                {...field}
                            />
                        )}
                    />
            </Grid>
        </>
    )
}